import React from 'react';
import { Card, CardBody } from '@material-tailwind/react';
import { formatMoney } from '../../shared/formatMoney';

const OverviewStatsCards = ({ summary }) => (
  <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
    {[
      ['Invoices', Number(summary.invoice_count || 0)],
      ['Gross', formatMoney(summary.gross_amount || 0)],
      ['Net', formatMoney(summary.net_amount || 0)],
      ['Paid invoices', Number(summary.paid_invoice_count || 0)]
    ].map(([label, value]) => (
      <Card key={label} className="shadow-lg">
        <CardBody>
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</div>
          <div className={`mt-2 text-3xl font-bold ${label === 'Net' ? 'text-emerald-700' : 'text-slate-900'}`}>{value}</div>
        </CardBody>
      </Card>
    ))}
  </div>
);

export default OverviewStatsCards;
